export const SUPPORTED_COUNTRIES = ['be', 'nl']

export const isSupportedCountry = country => SUPPORTED_COUNTRIES.includes(country)

export const getLanguageOptions = t => ({
  be: [
    { FR: t('additionalSales:language_picker.french') },
    { NL: t('additionalSales:language_picker.dutch') },
    { EN: t('additionalSales:language_picker.english') },
  ],
  nl: [{ NL: t('additionalSales:language_picker.dutch') }],
  fr: [{ FR: t('additionalSales:language_picker.french') }],
})

export function getAdditionalRequiredData(country, data, t) {
  if (!isSupportedCountry(country)) {
    return []
  }

  return [
    {
      name: t('additionalSales:list_data.language'),
      status: data?.language !== null,
    },
  ]
}
